module.exports = __webpack_public_path__ + "static/media/classicos_masculino_acessorios.9a320783.jpg";